// extracted by mini-css-extract-plugin
export default {"recommended-reports":"RecommendedReports_recommended-reports__J0vZT","recommended-reports-items":"RecommendedReports_recommended-reports-items__gtxIJ"};